import './GlowSubWidgets.css';
import React, {useState} from "react";

function HealthBlock(props) {
    const [activeStep, setActiveStep] = useState(1)

    const healthRoutineSteps = [
        "head to the gym", 
        "open wsf and do workout",
        "return home",
        "drink protein shake",
        "take a shower",
    ]

    function changeStep(trigger) {
        if (trigger === activeStep) {
            setActiveStep(activeStep+1)
        }
    }

    return (
        <div className="eatingRoutine">                
<p className="glowHeaderText"> fitness </p>
                <p className="eatingHeaderSubText"> {healthRoutineSteps[activeStep - 1]} </p>
                {activeStep === 6 &&
                    <p className="eatingHeaderSubText"> completed fitness routine - chill out</p>
                }
                <div className="eatingRoutineBoxRow">
                        <div className="boxLineScreen"></div>
                        <div onClick={() => changeStep(1)} className="boxScreen">
                            {activeStep > 1 &&
                                <div className="innerBoxScreen innerMorning1"></div>
                            }
                            {activeStep === 1 &&
                                <div className="innerBoxScreen screenPulsing innerMorning1"></div>
                            }
                        </div>
                        <div onClick={() => changeStep(2)} className="boxScreen">
                            {activeStep > 2 &&
                                <div className="innerBoxScreen innerMorning2"></div>
                            }
                            {activeStep === 2 &&
                                <div className="innerBoxScreen screenPulsing innerMorning2"></div>
                            }
                        </div>
                        <div onClick={() => changeStep(3)} className="boxScreen">
                            {activeStep > 3 &&
                                <div className="innerBoxScreen innerMorning3"></div>
                            }
                            {activeStep === 3 &&
                                <div className="innerBoxScreen screenPulsing innerMorning3"></div>
                            }
                        </div>
                        <div onClick={() => changeStep(4)} className="boxScreen">
                            {activeStep > 4 &&
                                <div className="innerBoxScreen innerMorning4"></div>
                            }
                            {activeStep === 4 &&
                                <div className="innerBoxScreen screenPulsing innerMorning4"></div>
                            }
                        </div>
                        <div onClick={() => changeStep(5)} className="boxScreen">
                            {activeStep > 5 &&
                                <div className="innerBoxScreen innerMorning5"></div>
                            }
                            {activeStep === 5 &&
                                <div className="innerBoxScreen screenPulsing innerMorning5"></div>
                            }
                        </div>
                        </div>

        </div>
    )
}

export default HealthBlock;